/**
 * @generated SignedSource<<5c21880761c5327ac7dc5d2efb2052df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly$data = {
  readonly endWeekday: number | null;
  readonly startWeekday: number | null;
  readonly " $fragmentType": "TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly";
};
export type TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly$key = {
  readonly " $data"?: TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleWeeklyWeekdayIndicator_RoutineScheduleWeekly",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startWeekday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endWeekday",
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleWeekly",
  "abstractKey": null
};

(node as any).hash = "7cf81d61711164e47b9f028016c99a11";

export default node;
